import PropTypes from 'prop-types';

const pathwayServiceShape = PropTypes.shape({
  isRegistered: PropTypes.func,
  register: PropTypes.func,
  createPathway: PropTypes.func,
  getPathway: PropTypes.func,
  deletePathway: PropTypes.func,

  subscribeToPathway: PropTypes.func,
  notifyUpdate: PropTypes.func,
});

export default pathwayServiceShape;
